import type { z } from 'zod';

import type {
    allowedRoleIdSchema,
    authTypeSchema,
    invitationMethodSchema,
    invitationOptionsSchema,
    paginatedTenantMembersSchema,
    paginationSchema,
    tenantMemberSchema,
    tenantMemberStatusSchema,
} from './schemas';

export type AllowedRoleId = z.infer<typeof allowedRoleIdSchema>;
export type TenantMemberStatus = z.infer<typeof tenantMemberStatusSchema>;
export type AuthType = z.infer<typeof authTypeSchema>;
export type InvitationMethod = z.infer<typeof invitationMethodSchema>;
export type InvitationOptions = z.infer<typeof invitationOptionsSchema>;
export type TenantMember = z.infer<typeof tenantMemberSchema>;
export type Pagination = z.infer<typeof paginationSchema>;
export type PaginatedTenantMembers = z.infer<typeof paginatedTenantMembersSchema>;

export const ALLOWED_ROLES: readonly AllowedRoleId[] = ['user', 'job_architect', 'reviewer', 'viewer'] as const;

export type OrganizationUsersParams = {
    readonly page?: number;
    readonly searchTerm?: string;
    readonly size?: number;
    readonly sortOrder?: 'asc' | 'desc';
};

export type InviteUserRequest = {
    readonly emailAddress: string;
    readonly firstName: string;
    readonly inviteLanguage?: string;
    readonly lastName: string;
    readonly roles?: readonly AllowedRoleId[];
};

export type UpdateUserRolesRequest = {
    readonly roles: readonly AllowedRoleId[];
};

export type DeleteResult = {
    readonly failed: readonly { readonly error: Error; readonly userId: string }[];
    readonly successful: readonly string[];
};
